import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';

export interface Period {
    value: number, label: string
}

export enum ValidityPeriodSize {
    SIZE_45 = 'size_45', // Default
    SIZE_65 = 'size_65',
    SIZE_75 = 'size_75'
}

@Component({
    selector: 'validity-period',
    templateUrl: './validity-period.component.html',
    styleUrls: ['./validity-period.component.scss']
})
export class ValidityPeriodComponent extends BaseWithBundleComponent
                                     implements OnInit {

    @Input()
    public label?: string;

    @Input()
    public size?: ValidityPeriodSize;

    @Input()
    public periods?: Period[];

    @Input()
    public selectedPeriod?: number;

    @Output()
    public selectedPeriodChange = new EventEmitter<number>();

    @Input()
    public invalid: boolean;

    constructor(protected componentServiceBundle: ComponentServiceBundle) {
        super(componentServiceBundle);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.size = this.size || ValidityPeriodSize.SIZE_45;

        if (!this.periods || this.periods.length === 0) {
            this.initDefaultPeriods();
        }
    }

    protected initDefaultPeriods(): void {
        this.periods = [
            { value: 24, label: `24${this.translateService.instant('common.label.hour_code')}`},
            { value: 36, label: `36${this.translateService.instant('common.label.hour_code')}`},
            { value: 48, label: `48${this.translateService.instant('common.label.hour_code')}`},
            { value: 60, label: `60${this.translateService.instant('common.label.hour_code')}`},
            { value: 72, label: `72${this.translateService.instant('common.label.hour_code')}`},
            { value: 84, label: `84${this.translateService.instant('common.label.hour_code')}`}
        ];
    }

    public selectPeriod(period: Period): void {
        if (!this.disabled) {
            this.selectedPeriod = period.value === this.selectedPeriod ? null : period.value;
            this.selectedPeriodChange.emit(this.selectedPeriod);
        }
    }
}
